import { PropsWithChildren } from 'react';

type TitlePageProps = {
  header: JSX.Element;
};

export const HeaderPage = (p: PropsWithChildren<TitlePageProps>) => (
  <div>
    <div className="flex flex-row justify-between items-center">{p.header}</div>
    <div>{p.children}</div>
  </div>
);
